export default () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('success')) {
        const successMessage = document.getElementById('successMessage');
        if (successMessage) {
            successMessage.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
};
